/**
 * Dot-path access from the payload root (`operator.foo`, `operator.bar.0.content`).
 * Array indices are numeric segments. Escaping for literal dots in keys is not supported (none in Buxus payloads today).
 */
export function getAt(root: unknown, dotPath: string): unknown {
  if (!dotPath) return undefined;
  const parts = dotPath.split(".");
  let cur: unknown = root;
  for (const p of parts) {
    if (cur == null || typeof cur !== "object") return undefined;
    const rec = cur as Record<string, unknown>;
    if (/^\d+$/.test(p)) {
      if (!Array.isArray(cur)) return undefined;
      cur = cur[Number(p)];
    } else {
      cur = rec[p];
    }
  }
  return cur;
}

export function getString(root: unknown, dotPath: string): string | undefined {
  const v = getAt(root, dotPath);
  return typeof v === "string" ? v : undefined;
}
